import React, { useEffect, useState } from 'react';
import Button, { InlineTextButton, PrimaryButton, SecondaryButton } from '../Button/Button';
import css from './AskForStaffButton.module.css';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../config';
import Modal from '../Modal/Modal';
import { manageDisableScrolling } from '../../ducks/UI.duck';

function AskForStaffButton() {
  const currentUser = useSelector(state => state.user.currentUser);
  const dispatch = useDispatch();
  const [showDisableListingCreationModal, setShowDisableListingCreationModal] = useState(false);

  const onManageDisableScrolling = (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling));

  const showModal = e => {
    e.preventDefault();
    setShowDisableListingCreationModal(true);
  };

  const isListingCreationEnabled = !!(config.isListinCreationEnabled
    ? true
    : currentUser?.attributes?.profile?.metadata?.canCreateListing);

  return (
    <div className={css.staffbtn}>
      {isListingCreationEnabled ? (
        <NamedLink name="NewListingPage">
          <InlineTextButton className={css.askForStaffbtn}>
            <FormattedMessage id="AdminStaffPageMain.askForStaff" />
          </InlineTextButton>
        </NamedLink>
      ) : (
        <SecondaryButton className={css.askForStaffbtn} onClick={showModal}>
          <FormattedMessage id="AdminStaffPageMain.askForStaff" />
        </SecondaryButton>
      )}
      <Modal
        id="askForStaff.button"
        isOpen={showDisableListingCreationModal}
        onClose={() => {
          setShowDisableListingCreationModal(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
      >
        <div className={css.listingCreationDisabledContent}>
          <FormattedMessage id="AdminStaffPageMain.askForStaff.listingDisabled.title" />
        </div>
      </Modal>
    </div>
  );
}

export default AskForStaffButton;
